import { Pipe, PipeTransform } from '@angular/core';

import { PickListItemStatus } from '../interfaces/picklist.interface';

@Pipe({
  name: 'picklistItemClass',
})
export class PicklistItemClassPipe implements PipeTransform {
  transform(status :PickListItemStatus) :string[] {
    let color = 'red';
    switch (status) {
      case PickListItemStatus.IN_PROGRESS:
        color = 'yellow';
        break;

      case PickListItemStatus.PICKED:
      case PickListItemStatus.SHIPPED:
        color = 'green';
        break;

      case PickListItemStatus.SPLIT:
        color = 'blue';
        break;

      default:
        break;
    }

    return [
      `text-${color}-800`,
      `bg-${color}-200`,
      `hover:${color}-400`,
      `active:${color}-500`,
      `focus:${color}-400`,
    ];
  }
}
